export default "__VITE_ASSET__CR$COL7i__"